import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
const RevenueChart = () => {
  const [activeTab, setActiveTab] = useState('mrr');
  // This would normally come from an API or state management
  const chartData = {
    mrr: [{
      month: 'Jan',
      value: 18500
    }, {
      month: 'Feb',
      value: 19200
    }, {
      month: 'Mar',
      value: 20100
    }, {
      month: 'Apr',
      value: 21000
    }, {
      month: 'May',
      value: 21800
    }, {
      month: 'Jun',
      value: 22500
    }, {
      month: 'Jul',
      value: 23200
    }, {
      month: 'Aug',
      value: 23900
    }, {
      month: 'Sep',
      value: 24531
    }]
  };
  // Calculate the maximum value for scaling
  const maxValue = Math.max(...chartData.mrr.map(item => item.value));
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-2 sm:mb-0">
          Revenue Growth
        </h2>
        <div className="flex space-x-1 bg-gray-100 p-1 rounded-md">
          <button className={`px-3 py-1 text-sm rounded-md ${activeTab === 'mrr' ? 'bg-white shadow-sm' : 'text-gray-600'}`} onClick={() => setActiveTab('mrr')}>
            MRR
          </button>
          <button className={`px-3 py-1 text-sm rounded-md ${activeTab === 'arr' ? 'bg-white shadow-sm' : 'text-gray-600'}`} onClick={() => setActiveTab('arr')}>
            ARR
          </button>
          <button className={`px-3 py-1 text-sm rounded-md ${activeTab === 'newMrr' ? 'bg-white shadow-sm' : 'text-gray-600'}`} onClick={() => setActiveTab('newMrr')}>
            New MRR
          </button>
        </div>
      </div>
      <div className="h-64 relative">
        <div className="absolute inset-0 flex items-end">
          {chartData.mrr.map((item, index) => {
          const height = item.value / maxValue * 100;
          return <div key={index} className="flex-1 flex flex-col items-center justify-end h-full">
                <div className="w-full max-w-[30px] rounded-t bg-blue-500 hover:bg-blue-600 transition-all cursor-pointer relative group" style={{
              height: `${height}%`
            }}>
                  <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    ${item.value.toLocaleString()}
                  </div>
                </div>
                <span className="text-xs text-gray-500 mt-2">{item.month}</span>
              </div>;
        })}
        </div>
      </div>
      <div className="flex items-center justify-between mt-6 pt-4 border-t border-gray-100">
        <div>
          <p className="text-sm text-gray-500">Current MRR</p>
          <p className="text-xl font-bold">$24,531</p>
        </div>
        <button className="flex items-center text-sm text-blue-600 font-medium hover:text-blue-800">
          View detailed report
          <ArrowRightIcon size={16} className="ml-1" />
        </button>
      </div>
    </div>;
};
export default RevenueChart;